// Details page coordinates property tabs and record actions.
import cloneDeep from "lodash/cloneDeep";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

import {
  fetchQueryIdForSelectedProperty,
  reaetSendRecordDataToBackEndReducer,
  resetCalulatorApiResultToInintal,
  resetDataSet,
  resetMaterailSearchReucer,
  resetsearchResultsFromLabvantageAPiToInintal,
  sendRecordDataToBackEnd,
  setSendRecordDataToBackEndReducerStatus,
} from "../../axios/index";
import DefaultBreadCrumb from "../breadcrumb";
import { autoCalulation } from "../utils/calculatorUtils";
import ActionButtons from "./actionButtons";
import AdvanceSearch from "./advancedSearch";
import InputGrid from "./container";
import DeletePopupWindow from "./deletePopupWindow";
import Header from "./header";
import SaveMaterialPopup from "./savePopupWindow";

const Details = ({ breadCrumbData, moduleName, defaultMaterialDataSet, fields, urlId, urlParams }) => {
  const dispatch = useDispatch();

  const originalMaterialDataSet = useSelector((state) => state.MaterailsDetail);
  const recordUpdateApiStatus = useSelector((state) => state.recordUpdateApi);
  const userInfo = useSelector((state) => state.userInfo);

  const [editStatus, setEditStatus] = React.useState(false);
  const [saveEvent, setSaveEvent] = React.useState(false);
  const [deleteEvent, setDeleteEvent] = React.useState(false);
  const [moduleFieldDataSet, setModuleFieldDataSet] = React.useState({});
  const [advancedSearchEvent, setAdvancedSearchEvent] = React.useState(false);
  const [graphVisualizer, setGraphVisualizer] = React.useState(false);
  const [advancedSearchEventType, setAdvancedSearchEventType] = React.useState("advancedSearch");
  const [advancedSearchMetaData, setAdvancedSearchMetaData] = React.useState({});

  const navigate = useNavigate();
  const location = useLocation();

  const ensureSamOneSecondAulField = (dataSet) => {
    const next = cloneDeep(dataSet || {});
    if (!next.sam || !Array.isArray(next.sam.propertyData)) return next;

    const hasOneSecondAul = next.sam.propertyData.some((row) => Object.prototype.hasOwnProperty.call(row, "1secondAUL"));
    if (hasOneSecondAul) return next;

    const maxIndex = next.sam.propertyData.findIndex((row) => Object.prototype.hasOwnProperty.call(row, "maxCapacity"));
    if (maxIndex < 0) return next;

    const maxRow = next.sam.propertyData[maxIndex].maxCapacity;
    if (!maxRow || !maxRow.propertyMetaData) return next;

    const oneSecondMeta = {
      ...maxRow.propertyMetaData,
      dbColumnName: "1secondAUL",
      fieldLabel: "1sec AUL",
      labVantageApi: false,
    };

    const oneSecondRow = {
      "1secondAUL": {
        value: null,
        virtual: false,
        valueTypeArray: false,
        dataSource: {
          type: "",
          creationDate: "",
          propertyName: "1secondAUL",
          metaData: {
            description: "No metadata available for 1sec AUL",
          },
        },
        propertyMetaData: oneSecondMeta,
      },
    };

    next.sam.propertyData.splice(maxIndex + 1, 0, oneSecondRow);
    return next;
  };

  useEffect(() => {
    setModuleFieldDataSet(ensureSamOneSecondAulField(defaultMaterialDataSet));
    if (urlParams.id === -1 || urlParams.id === "-1") {
      setEditStatus(true);
    } else {
      setEditStatus(false);
    }
  }, [defaultMaterialDataSet, urlParams]);

  useEffect(() => {
    if (recordUpdateApiStatus.responseType === "success" && recordUpdateApiStatus.loading === false) {
      let tempPath = "../" + moduleName + "-details/" + recordUpdateApiStatus.data.key;

      if (recordUpdateApiStatus.data.key !== Number(urlParams.id)) {
        navigate(tempPath, { replace: true });
      }
      setEditStatus(false);
    }
  }, [recordUpdateApiStatus]);

  const handleAdvancedSearchStatus = (type, currentStatus) => {
    setAdvancedSearchEvent(currentStatus);
    if (type === "graph") {
      setGraphVisualizer(currentStatus);
    }
    setAdvancedSearchEventType("advancedSearch");
    dispatch(resetMaterailSearchReucer({}));
    dispatch(resetCalulatorApiResultToInintal());
    dispatch(resetsearchResultsFromLabvantageAPiToInintal());
    document.body.style.overflow = "hidden";
    document.body.classList.add("no-scroll");
  };

  const handleLabVantageApiCallPopup = (status, item, key, module, index, fieldLabel) => {
    setAdvancedSearchEventType("labvantageSearch");
    setAdvancedSearchEvent(status);
    setAdvancedSearchMetaData({ item: item, key: key, module: module, index: index, fieldLabel: fieldLabel });
    dispatch(resetMaterailSearchReucer({}));
    dispatch(resetCalulatorApiResultToInintal());
    dispatch(resetsearchResultsFromLabvantageAPiToInintal());
    dispatch(fetchQueryIdForSelectedProperty({ propertyName: key, propertyType: module }));
    document.body.style.overflow = "hidden";
    document.body.classList.add("no-scroll");
  };

  const handleEditStatus = (status) => {
    setEditStatus(status);
    let newMaterialDataSet = cloneDeep(originalMaterialDataSet);
    if (!status) {
      dispatch(resetDataSet(newMaterialDataSet));
    }
    if (!status && (urlParams.id === "-1" || urlParams.id === -1)) {
      let tempPath = "../";
      navigate(tempPath, { replace: true });
    }
    dispatch(reaetSendRecordDataToBackEndReducer({}));
  };
  const handleSaveEvent = (status) => {
    setSaveEvent(status);
  };
  const handleDeletEvent = (status) => {
    setDeleteEvent(status);
  };
  const compareWithOriginalDataSet = (key, moduleFieldDataSet) => {
    let tempCounter = 0;
    Object.keys(moduleFieldDataSet.header).map((tempHeaderKey) => {
      if (
        originalMaterialDataSet["data"][key]["header"][tempHeaderKey] !== moduleFieldDataSet["header"][tempHeaderKey] &&
        moduleFieldDataSet["header"]["edited"] === true
      ) {
        tempCounter = tempCounter + 1;
      }
    });
    if (tempCounter === 0) {
      moduleFieldDataSet.propertyData.map((tempProperty, index) => {
        Object.keys(tempProperty).map((tempPropertyKey) => {
          if (
            originalMaterialDataSet["data"][key]["propertyData"][index][tempPropertyKey]["value"] !==
              tempProperty[tempPropertyKey]["value"] &&
            tempProperty[tempPropertyKey]["valueTypeArray"] !== true &&
            tempProperty[tempPropertyKey]["edited"] === true
          ) {
            tempCounter = tempCounter + 1;
          }
        });
      });
    }
    return tempCounter === 0 ? false : true;
  };
  const saveRecordEvent = (data) => {
    dispatch(reaetSendRecordDataToBackEndReducer({}));
    dispatch(setSendRecordDataToBackEndReducerStatus(true));
    if (data.saveType !== undefined && data.saveType !== undefined) {
      let statusType = data.statusType === "inDraft" ? "Draft" : "In Production";
      let tempModuleFieldDataSet = cloneDeep(moduleFieldDataSet);
      let materialId = tempModuleFieldDataSet?.material?.header?.key
      Object.keys(tempModuleFieldDataSet).map((key) => {
        tempModuleFieldDataSet["saveType"] = data.saveType;
        if (data.module === key && data.saveType === "new") {
          tempModuleFieldDataSet[key]["header"]["key"] = "";
          tempModuleFieldDataSet[key]["header"]["status"] = statusType;
          tempModuleFieldDataSet[key]["header"]["author"] = userInfo.sAMAccountName;
        } else if (data.module === key && data.saveType !== "new") {
          tempModuleFieldDataSet[key]["header"]["status"] = statusType;
          tempModuleFieldDataSet[key]["header"]["author"] = userInfo.sAMAccountName;
        } else if (data.module !== key) {
          if (compareWithOriginalDataSet(key, tempModuleFieldDataSet[key])) {
            tempModuleFieldDataSet[key]["header"]["key"] = "";
            tempModuleFieldDataSet[key]["header"]["status"] = statusType;
            tempModuleFieldDataSet[key]["header"]["author"] = userInfo.sAMAccountName;
          } else {
          }
        }
      });
      if(materialId)tempModuleFieldDataSet["materialId"]= materialId

      dispatch(sendRecordDataToBackEnd(tempModuleFieldDataSet));
    }
  };
  const handleHeaderDataUpdate = (data) => {
    let tempDataSet = { ...moduleFieldDataSet };
    tempDataSet[data.module]["header"][data.key] = data.e;
    let editStatus = false;
    Object.keys(tempDataSet[data.module]["header"]).map((key) => {
      if (
        key !== "edited" &&
        originalMaterialDataSet.data[data.module]["header"][key] !== tempDataSet[data.module]["header"][key]
      ) {
        editStatus = true;
      }
    });

    tempDataSet[data.module]["header"]["edited"] = editStatus;
    setModuleFieldDataSet({ ...tempDataSet });
  };

  const closeModal = () => {
    setSaveEvent(false);
    setDeleteEvent(false);
    dispatch(reaetSendRecordDataToBackEndReducer({}));
  };

  const handleFieldDataUpdate = (data) => {
    setModuleFieldDataSet(data);
  };

  const importSearchResultSet = (data) => {
    let tempModuleFieldDataSet = cloneDeep(moduleFieldDataSet);
    if (data.moduleType === "fiber" && Object.keys(data.dataSet).length > 0) {
      tempModuleFieldDataSet["fiber"]["header"]["description"] = data.dataSet.fiberDescription;
      tempModuleFieldDataSet["fiber"]["header"]["name"] = data.dataSet.fiberName;
      tempModuleFieldDataSet["fiber"]["header"]["version"] = data.dataSet.version;
      tempModuleFieldDataSet["fiber"]["header"]["key"] = "";
      moduleFieldDataSet["fiber"]["propertyData"].map((item, index) => {
        return Object.keys(item).map((currentItemKey) => {
          if (data.dataSet[currentItemKey] !== -1) {
            tempModuleFieldDataSet["fiber"]["propertyData"][index][currentItemKey]["edited"] = false;
            tempModuleFieldDataSet["fiber"]["propertyData"][index][currentItemKey]["value"] =
              data.dataSet[currentItemKey];
            tempModuleFieldDataSet["fiber"]["propertyData"][index][currentItemKey]["dataSource"] = data.dataSource;
          }
        });
      });
      tempModuleFieldDataSet = autoCalulation("fiber", tempModuleFieldDataSet, fields);
      setModuleFieldDataSet(tempModuleFieldDataSet);
    } else if (data.moduleType === "fiberDefault" && Object.keys(data.dataSet).length > 0) {
      tempModuleFieldDataSet["fiber"] = data.dataSet.fiber;
      tempModuleFieldDataSet = autoCalulation("fiber", tempModuleFieldDataSet, fields);
      setModuleFieldDataSet(tempModuleFieldDataSet);
    } else if (data.moduleType === "sam" && Object.keys(data.dataSet).length > 0) {
      tempModuleFieldDataSet[data.moduleType] = data.dataSet.sam;
      tempModuleFieldDataSet = autoCalulation("sam", tempModuleFieldDataSet, fields);
      setModuleFieldDataSet(ensureSamOneSecondAulField(tempModuleFieldDataSet));
    } else if (data.moduleType === "labvantage" && Object.keys(data.dataSet).length > 0) {
      const targetModule = advancedSearchMetaData.module;
      const directTargetFieldKey = data.dataSet.__targetFieldKey || advancedSearchMetaData.key;
      const directSelectedDbColumnName = data.dataSet.__selectedDbColumnName;
      const targetFieldLabel = advancedSearchMetaData?.fieldLabel;
      const propertyRowsForDirectWrite = tempModuleFieldDataSet[targetModule]["propertyData"] || [];
      const normalizedDirectTargetFieldKey = String(directTargetFieldKey || "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .toLowerCase();
      const normalizedDirectDbColumnName = String(directSelectedDbColumnName || "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .toLowerCase();

      const tryParseNumber = (v) => {
        if (v === undefined || v === null) return null;
        if (typeof v === "number") return Number.isNaN(v) ? null : v;
        const matched = String(v).replace(/,/g, "").match(/-?\d+(\.\d+)?/);
        if (!matched) return null;
        const parsed = Number(matched[0]);
        return Number.isNaN(parsed) ? null : parsed;
      };

      const normalizeImportedNumericValue = (rawValue, propertyMetaData, targetFieldKey) => {
        const parsed = tryParseNumber(rawValue);
        if (parsed === null) return null;

        const normalizedKey = String(targetFieldKey || "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
        const normalizedDbColumn = String(propertyMetaData?.dbColumnName || "")
          .replace(/[^a-zA-Z0-9]/g, "")
          .toLowerCase();
        const normalizedLabel = String(propertyMetaData?.fieldLabel || "")
          .replace(/[^a-zA-Z0-9]/g, "")
          .toLowerCase();

        const isMoistureField =
          normalizedKey.includes("moist") || normalizedDbColumn.includes("moist") || normalizedLabel.includes("moist");
        const isGelBedField =
          normalizedKey.includes("gelbed") ||
          normalizedDbColumn.includes("gelbed") ||
          normalizedLabel.includes("gelbed") ||
          normalizedKey.includes("permeability") ||
          normalizedDbColumn.includes("permeability") ||
          normalizedLabel.includes("permeability");
        const isDryGelDensityField =
          normalizedKey.includes("drygeldensity") ||
          normalizedDbColumn.includes("drygeldensity") ||
          normalizedLabel.includes("drygeldensity");

        // Dry Gel Density must keep its full measured precision - skip the
        // configured fieldMinRange/fieldMaxRange clamp (those bounds are
        // typical-value hints, not hard limits, for this field).
        if (isDryGelDensityField) {
          return parsed;
        }

        const min = isGelBedField
          ? 0
          : typeof propertyMetaData?.fieldMinRange === "number"
          ? propertyMetaData.fieldMinRange
          : null;
        const max = isGelBedField
          ? 5000
          : typeof propertyMetaData?.fieldMaxRange === "number"
          ? propertyMetaData.fieldMaxRange
          : null;

        let bounded = parsed;
        if (typeof min === "number") bounded = Math.max(min, bounded);
        if (typeof max === "number") bounded = Math.min(max, bounded);

        if (isGelBedField) {
          return Number(bounded.toFixed(2));
        }

        if (isMoistureField) {
          return Number(bounded.toFixed(1));
        }

        return bounded;
      };

      // Moisture-specific direct path (from scratch) before any generic handling.
      const payloadHasMoistureKey = Object.keys(data.dataSet || {}).some((k) =>
        String(k || "")
          .replace(/[^a-zA-Z0-9]/g, "")
          .toLowerCase()
          .includes("moist")
      );
      const payloadHasGelBedKey = Object.keys(data.dataSet || {}).some((k) => {
        const normalizedKey = String(k || "")
          .replace(/[^a-zA-Z0-9]/g, "")
          .toLowerCase();
        return normalizedKey.includes("gelbed") || normalizedKey.includes("permeability");
      });
      const normalizedTargetLabel = String(targetFieldLabel || "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .toLowerCase();
      const isMoistureTargetFresh =
        normalizedDirectTargetFieldKey === "moisture" ||
        normalizedDirectDbColumnName.includes("moist") ||
        normalizedTargetLabel.includes("moisture") ||
        payloadHasMoistureKey;
      const isGelBedTargetFresh =
        normalizedDirectTargetFieldKey === "gelbedpermeability" ||
        normalizedDirectDbColumnName.includes("gelbed") ||
        normalizedTargetLabel.includes("gelbedpermeability") ||
        payloadHasGelBedKey;

      const specialFieldKeyFromPayload = data.dataSet.__specialFieldKey;
      const specialFieldValueFromPayload = data.dataSet.__specialFieldValue;
      const normalizedSpecialFieldKey = String(specialFieldKeyFromPayload || "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .toLowerCase();
      const isExplicitSpecialField = normalizedSpecialFieldKey === "gelbedpermeability";

      // Fresh special-field import path for Gel Bed Permeability only.
      // Moisture follows the same generic direct path as Freeswell.
      if (isExplicitSpecialField || isGelBedTargetFresh) {
        const canonicalFieldKey =
          isExplicitSpecialField
            ? "gelBedPermeability"
            : "gelBedPermeability";
        const specialLabelToken = "gelbedpermeability";

        const specialRowIndex = propertyRowsForDirectWrite.findIndex((row) => {
          if (Object.prototype.hasOwnProperty.call(row, canonicalFieldKey)) return true;
          const rowKey = Object.keys(row || {})[0];
          const normalizedRowKey = String(rowKey || "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
          const normalizedRowLabel = String(row?.[rowKey]?.propertyMetaData?.fieldLabel || "")
            .replace(/[^a-zA-Z0-9]/g, "")
            .toLowerCase();
          return normalizedRowKey.includes(specialLabelToken) || normalizedRowLabel.includes(specialLabelToken);
        });

        if (specialRowIndex > -1) {
          const specialFieldKey =
            Object.prototype.hasOwnProperty.call(propertyRowsForDirectWrite[specialRowIndex], canonicalFieldKey)
              ? canonicalFieldKey
              : Object.keys(propertyRowsForDirectWrite[specialRowIndex] || {})[0];

          const specialPayloadKey = Object.keys(data.dataSet || {}).find((k) => {
            const normalizedKey = String(k || "")
              .replace(/[^a-zA-Z0-9]/g, "")
              .toLowerCase();
            return normalizedKey.includes("gelbed") || normalizedKey.includes("permeability");
          });

          let specialValue =
            specialFieldValueFromPayload ??
            data.dataSet[canonicalFieldKey] ??
            data.dataSet.__selectedInputValue ??
            data.dataSet.__selectedValue ??
            (data.dataSet.__selectedDbColumnName ? data.dataSet[data.dataSet.__selectedDbColumnName] : undefined) ??
            (specialPayloadKey ? data.dataSet[specialPayloadKey] : undefined) ??
            data.dataSet.avgvalue;

          specialValue = normalizeImportedNumericValue(
            specialValue,
            propertyRowsForDirectWrite[specialRowIndex]?.[specialFieldKey]?.propertyMetaData,
            specialFieldKey
          );

          if (specialValue !== undefined && specialValue !== null && specialFieldKey) {
            const specialCell = propertyRowsForDirectWrite[specialRowIndex][specialFieldKey];
            specialCell["value"] = specialValue;
            specialCell["edited"] = false;
            specialCell["virtual"] = false;
            specialCell.dataSource = data.dataSource;
            tempModuleFieldDataSet[targetModule]["propertyData"][specialRowIndex][specialFieldKey] = specialCell;

            tempModuleFieldDataSet = autoCalulation(targetModule, tempModuleFieldDataSet, fields);

            const refreshedRows = tempModuleFieldDataSet[targetModule]["propertyData"] || [];
            const refreshedSpecialIndex = refreshedRows.findIndex((row) =>
              Object.prototype.hasOwnProperty.call(row, specialFieldKey)
            );
            if (refreshedSpecialIndex > -1) {
              tempModuleFieldDataSet[targetModule]["propertyData"][refreshedSpecialIndex][specialFieldKey]["value"] = specialValue;
              tempModuleFieldDataSet[targetModule]["propertyData"][refreshedSpecialIndex][specialFieldKey]["edited"] = false;
              tempModuleFieldDataSet[targetModule]["propertyData"][refreshedSpecialIndex][specialFieldKey]["virtual"] = false;
              tempModuleFieldDataSet[targetModule]["propertyData"][refreshedSpecialIndex][specialFieldKey].dataSource = data.dataSource;
            }

            setModuleFieldDataSet(tempModuleFieldDataSet);
            closeAdvancedSearchModal(false);
            return;
          }
        }
      }

      // Vortex-style deterministic path: write selected value directly to target field first.
      if (directTargetFieldKey) {
        const directRowIndex = propertyRowsForDirectWrite.findIndex((row) =>
          Object.prototype.hasOwnProperty.call(row, directTargetFieldKey)
        );

        if (directRowIndex > -1 && propertyRowsForDirectWrite[directRowIndex][directTargetFieldKey]) {
          let directValue =
            data.dataSet.__selectedInputValue ??
            data.dataSet.__selectedValue ??
            data.dataSet[directTargetFieldKey] ??
            (data.dataSet.__selectedDbColumnName ? data.dataSet[data.dataSet.__selectedDbColumnName] : undefined) ??
            data.dataSet.avgvalue;

          const directCell = propertyRowsForDirectWrite[directRowIndex][directTargetFieldKey];
          if (directCell?.propertyMetaData?.fieldType === "number") {
            directValue = normalizeImportedNumericValue(
              directValue,
              directCell?.propertyMetaData,
              directTargetFieldKey
            );
          }

          if (directValue !== undefined && directValue !== null && directValue !== "") {
            directCell["value"] = directValue === "-" ? null : directValue;
            directCell["edited"] = false;
            directCell["virtual"] = false;
            directCell.dataSource = data.dataSource;
            tempModuleFieldDataSet[targetModule]["propertyData"][directRowIndex][directTargetFieldKey] = directCell;
            tempModuleFieldDataSet = autoCalulation(targetModule, tempModuleFieldDataSet, fields);

            const refreshedRows = tempModuleFieldDataSet[targetModule]["propertyData"] || [];
            const refreshedDirectIndex = refreshedRows.findIndex((row) =>
              Object.prototype.hasOwnProperty.call(row, directTargetFieldKey)
            );
            if (refreshedDirectIndex > -1) {
              tempModuleFieldDataSet[targetModule]["propertyData"][refreshedDirectIndex][directTargetFieldKey]["value"] =
                directValue === "-" ? null : directValue;
              tempModuleFieldDataSet[targetModule]["propertyData"][refreshedDirectIndex][directTargetFieldKey]["edited"] = false;
              tempModuleFieldDataSet[targetModule]["propertyData"][refreshedDirectIndex][directTargetFieldKey]["virtual"] = false;
              tempModuleFieldDataSet[targetModule]["propertyData"][refreshedDirectIndex][directTargetFieldKey].dataSource = data.dataSource;
            }

            setModuleFieldDataSet(tempModuleFieldDataSet);
            closeAdvancedSearchModal(false);
            return;
          }
        }
      }

      const normalizeFieldKey = (value) =>
        String(value || "")
          .replace(/[^a-zA-Z0-9]/g, "")
          .toLowerCase();

      // Deterministic forced import path (used for moisture to mirror working field behavior).
      if (data.dataSet.__forceFieldKey) {
        const forcedFieldKey = data.dataSet.__forceFieldKey;
        const forcedFieldLabel = data.dataSet.__forceFieldLabel;
        const propertyRows = tempModuleFieldDataSet[targetModule]["propertyData"] || [];
        const normalizedForcedKey = normalizeFieldKey(forcedFieldKey);
        const normalizedForcedLabel = normalizeFieldKey(forcedFieldLabel);

        let forcedRowIndex = propertyRows.findIndex((row) => Object.prototype.hasOwnProperty.call(row, forcedFieldKey));
        let resolvedForcedFieldKey = forcedFieldKey;

        if (forcedRowIndex === -1) {
          forcedRowIndex = propertyRows.findIndex((row) => {
            const rowKey = Object.keys(row || {})[0];
            if (!rowKey) return false;
            const normalizedRowKey = normalizeFieldKey(rowKey);
            const rowFieldLabel = row[rowKey]?.propertyMetaData?.fieldLabel;
            const normalizedRowLabel = normalizeFieldKey(rowFieldLabel);

            const keyMatch =
              normalizedRowKey === normalizedForcedKey ||
              normalizedRowKey.includes(normalizedForcedKey) ||
              normalizedForcedKey.includes(normalizedRowKey);

            const labelMatch =
              normalizedForcedLabel &&
              normalizedRowLabel &&
              (normalizedRowLabel === normalizedForcedLabel ||
                normalizedRowLabel.includes(normalizedForcedLabel) ||
                normalizedForcedLabel.includes(normalizedRowLabel));

            return keyMatch || labelMatch;
          });

          if (forcedRowIndex > -1) {
            resolvedForcedFieldKey = Object.keys(propertyRows[forcedRowIndex] || {})[0] || forcedFieldKey;
          }
        }

        // Final fallback for moisture-like labels/keys.
        if (forcedRowIndex === -1) {
          forcedRowIndex = propertyRows.findIndex((row) => {
            const rowKey = Object.keys(row || {})[0];
            if (!rowKey) return false;
            const rowFieldLabel = row[rowKey]?.propertyMetaData?.fieldLabel;
            return (
              normalizeFieldKey(rowKey).includes("moist") ||
              normalizeFieldKey(rowFieldLabel).includes("moist")
            );
          });
          if (forcedRowIndex > -1) {
            resolvedForcedFieldKey = Object.keys(propertyRows[forcedRowIndex] || {})[0] || forcedFieldKey;
          }
        }

        if (forcedRowIndex > -1 && propertyRows[forcedRowIndex][resolvedForcedFieldKey]) {
          const forcedCell = propertyRows[forcedRowIndex][resolvedForcedFieldKey];
          const toNumber = (v) => {
            if (v === undefined || v === null) return null;
            if (typeof v === "number") return Number.isNaN(v) ? null : v;
            const matched = String(v).replace(/,/g, "").match(/-?\d+(\.\d+)?/);
            if (!matched) return null;
            const parsed = Number(matched[0]);
            return Number.isNaN(parsed) ? null : parsed;
          };

          let forcedValue = data.dataSet.__forceValue;
          if (forcedValue === undefined || forcedValue === null || forcedValue === "") {
            forcedValue =
              data.dataSet.__selectedInputValue ??
              data.dataSet.__selectedValue ??
              data.dataSet[resolvedForcedFieldKey] ??
              (data.dataSet.__selectedDbColumnName ? data.dataSet[data.dataSet.__selectedDbColumnName] : undefined) ??
              data.dataSet.avgvalue;
          }
          if (forcedCell?.propertyMetaData?.fieldType === "number") {
            forcedValue = normalizeImportedNumericValue(
              forcedValue,
              forcedCell?.propertyMetaData,
              resolvedForcedFieldKey
            );
          }

          forcedCell["value"] = forcedValue === "-" ? null : forcedValue;
          forcedCell["edited"] = false;
          forcedCell["virtual"] = false;
          forcedCell.dataSource = data.dataSource;
          tempModuleFieldDataSet[targetModule]["propertyData"][forcedRowIndex][resolvedForcedFieldKey] = forcedCell;
          tempModuleFieldDataSet = autoCalulation(targetModule, tempModuleFieldDataSet, fields);

          const refreshedRows = tempModuleFieldDataSet[targetModule]["propertyData"] || [];
          const refreshedForcedIndex = refreshedRows.findIndex((row) =>
            Object.prototype.hasOwnProperty.call(row, resolvedForcedFieldKey)
          );
          if (refreshedForcedIndex > -1) {
            tempModuleFieldDataSet[targetModule]["propertyData"][refreshedForcedIndex][resolvedForcedFieldKey]["value"] =
              forcedValue === "-" ? null : forcedValue;
            tempModuleFieldDataSet[targetModule]["propertyData"][refreshedForcedIndex][resolvedForcedFieldKey]["edited"] = false;
            tempModuleFieldDataSet[targetModule]["propertyData"][refreshedForcedIndex][resolvedForcedFieldKey]["virtual"] = false;
            tempModuleFieldDataSet[targetModule]["propertyData"][refreshedForcedIndex][resolvedForcedFieldKey].dataSource = data.dataSource;
          }

          setModuleFieldDataSet(tempModuleFieldDataSet);
          closeAdvancedSearchModal(false);
          return;
        }
      }

      const requestedTargetFieldKey = data.dataSet.__targetFieldKey || advancedSearchMetaData.key;
      const normalizedRequestedTargetKey = normalizeFieldKey(requestedTargetFieldKey);
      const isMoistureTarget = normalizedRequestedTargetKey === "moisture";

      const propertyRows = tempModuleFieldDataSet[targetModule]["propertyData"] || [];
      const normalizedRequestedKey = normalizeFieldKey(requestedTargetFieldKey);
      const normalizedRequestedLabel = normalizeFieldKey(advancedSearchMetaData?.fieldLabel);

      let targetRowIndex = propertyRows.findIndex((row) =>
        Object.prototype.hasOwnProperty.call(row, requestedTargetFieldKey)
      );
      let targetFieldKey = requestedTargetFieldKey;

      // Deterministic override for Moisture: always map to moisture property row.
      if (isMoistureTarget) {
        const explicitMoistureRow = propertyRows.findIndex((row) =>
          Object.prototype.hasOwnProperty.call(row, "moisture")
        );
        if (explicitMoistureRow > -1) {
          targetRowIndex = explicitMoistureRow;
          targetFieldKey = "moisture";
        }
      }

      if (targetRowIndex === -1) {
        targetRowIndex = propertyRows.findIndex((row) => {
          const rowKey = Object.keys(row || {})[0];
          if (!rowKey) return false;

          const normalizedRowKey = normalizeFieldKey(rowKey);
          if (
            normalizedRowKey === normalizedRequestedKey ||
            normalizedRowKey.includes(normalizedRequestedKey) ||
            normalizedRequestedKey.includes(normalizedRowKey)
          ) {
            return true;
          }

          const rowMetaFieldLabel = row[rowKey]?.propertyMetaData?.fieldLabel;
          const normalizedRowLabel = normalizeFieldKey(rowMetaFieldLabel);

          return (
            normalizedRequestedLabel &&
            normalizedRowLabel &&
            (normalizedRowLabel === normalizedRequestedLabel ||
              normalizedRowLabel.includes(normalizedRequestedLabel) ||
              normalizedRequestedLabel.includes(normalizedRowLabel))
          );
        });

        if (targetRowIndex > -1) {
          targetFieldKey = Object.keys(propertyRows[targetRowIndex] || {})[0] || requestedTargetFieldKey;
        }
      }

      let safeTargetIndex = targetRowIndex > -1 ? targetRowIndex : advancedSearchMetaData.index;
      if (
        safeTargetIndex === undefined ||
        safeTargetIndex === null ||
        safeTargetIndex < 0 ||
        safeTargetIndex >= propertyRows.length
      ) {
        safeTargetIndex = 0;
      }

      if (!propertyRows[safeTargetIndex]) {
        return;
      }

      if (!propertyRows[safeTargetIndex][targetFieldKey]) {
        const fallbackRowKey = Object.keys(propertyRows[safeTargetIndex] || {})[0];
        if (!fallbackRowKey) {
          return;
        }
        targetFieldKey = fallbackRowKey;
      }

      let tempDataSet = tempModuleFieldDataSet[targetModule]["propertyData"][safeTargetIndex][targetFieldKey];

      // Labvantage payloads may return the selected value either as avgvalue
      // or under the requested db column key (e.g., samCRC, moisture, 0.3psiGBP).
      const selectedFieldKey = targetFieldKey;
      let importedValue = data.dataSet.__selectedInputValue;

      if (importedValue === undefined || importedValue === null || importedValue === "-") {
        importedValue = data.dataSet.__selectedValue;
      }
      const destinationFieldType = tempDataSet?.propertyMetaData?.fieldType;
      const fieldMinRange = tempDataSet?.propertyMetaData?.fieldMinRange;
      const fieldMaxRange = tempDataSet?.propertyMetaData?.fieldMaxRange;

      const tryParseNumeric = (value) => {
        if (value === undefined || value === null) return null;
        if (typeof value === "number") return Number.isNaN(value) ? null : value;
        if (typeof value === "string") {
          const cleaned = value.replace(/,/g, "").trim();
          if (!cleaned) return null;
          const matched = cleaned.match(/-?\d+(\.\d+)?/);
          if (!matched) return null;
          const parsed = Number(matched[0]);
          return Number.isNaN(parsed) ? null : parsed;
        }
        return null;
      };

      const isInDestinationRange = (numericValue) => {
        if (numericValue === null || numericValue === undefined || Number.isNaN(numericValue)) return false;
        const minOk = typeof fieldMinRange === "number" ? numericValue >= fieldMinRange : true;
        const maxOk = typeof fieldMaxRange === "number" ? numericValue <= fieldMaxRange : true;
        return minOk && maxOk;
      };

      if (importedValue === undefined || importedValue === null || importedValue === "-") {
        importedValue = data.dataSet[selectedFieldKey];
      }

      if (
        (importedValue === undefined || importedValue === null || importedValue === "-") &&
        data.dataSet.__selectedDbColumnName
      ) {
        importedValue = data.dataSet[data.dataSet.__selectedDbColumnName];
      }

      if (importedValue === undefined || importedValue === null || importedValue === "-") {
        importedValue = data.dataSet.avgvalue;
      }

      if (importedValue === undefined || importedValue === null || importedValue === "-") {
        const normalizedSelectedFieldKey = String(selectedFieldKey)
          .replace(/[^a-zA-Z0-9]/g, "")
          .toLowerCase();

        const normalizedMatchKey = Object.keys(data.dataSet).find((rowKey) => {
          const normalizedRowKey = String(rowKey)
            .replace(/[^a-zA-Z0-9]/g, "")
            .toLowerCase();
          return (
            normalizedRowKey === normalizedSelectedFieldKey ||
            normalizedRowKey.includes(normalizedSelectedFieldKey) ||
            normalizedSelectedFieldKey.includes(normalizedRowKey)
          );
        });

        if (normalizedMatchKey) {
          importedValue = data.dataSet[normalizedMatchKey];
        }
      }

      if (importedValue === undefined || importedValue === null || importedValue === "-") {
        const excludedKeys = new Set([
          "key",
          "requestid",
          "requestorname",
          "productcategory",
          "productdescription",
          "completeddt",
          "replicateid",
          "keyid1",
          "sampleid",
          "sampleId",
        ]);

        // Prefer numeric-looking candidates first for numeric destination fields.
        const numericCandidateKey = Object.keys(data.dataSet).find((rowKey) => {
          if (excludedKeys.has(String(rowKey).toLowerCase())) return false;
          const rowVal = data.dataSet[rowKey];
          return tryParseNumeric(rowVal) !== null;
        });

        if (numericCandidateKey) {
          importedValue = data.dataSet[numericCandidateKey];
        }

        if (importedValue === undefined || importedValue === null || importedValue === "-") {
          Object.keys(data.dataSet).some((rowKey) => {
            if (excludedKeys.has(String(rowKey).toLowerCase())) return false;
            const rowVal = data.dataSet[rowKey];
            if (rowVal !== undefined && rowVal !== null && rowVal !== "-") {
              importedValue = rowVal;
              return true;
            }
            return false;
          });
        }
      }

      if (selectedFieldKey === "SamRadius" || selectedFieldKey === "Times/TimedAUL") {
        importedValue = data.dataSet.keyid1 ?? importedValue;
      }

      if (destinationFieldType === "number") {
        const isMoistureField =
          String(selectedFieldKey || "").toLowerCase() === "moisture" ||
          String(tempDataSet?.propertyMetaData?.dbColumnName || "").toLowerCase() === "moisture" ||
          String(tempDataSet?.propertyMetaData?.fieldLabel || "").toLowerCase().includes("moisture");

        let moistureResolved = false;

        // Mimic working fields behavior for Moisture: use the exact selected value first.
        if (isMoistureField) {
          let moistureDirectValue =
            data.dataSet.__selectedInputValue ??
            data.dataSet.__selectedValue ??
            data.dataSet.moisture ??
            data.dataSet[selectedFieldKey] ??
            (data.dataSet.__selectedDbColumnName ? data.dataSet[data.dataSet.__selectedDbColumnName] : undefined) ??
            data.dataSet.avgvalue;

          // Fallback: choose first moisture-like key from payload.
          if (moistureDirectValue === undefined || moistureDirectValue === null || moistureDirectValue === "") {
            const moistureLikeKey = Object.keys(data.dataSet).find((k) => {
              const nk = String(k).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
              return nk.includes("moist");
            });
            if (moistureLikeKey) {
              moistureDirectValue = data.dataSet[moistureLikeKey];
            }
          }

          const parsedMoisture = tryParseNumeric(moistureDirectValue);
          if (parsedMoisture !== null) {
            importedValue = parsedMoisture;
            moistureResolved = true;
          }
        }

        if (!moistureResolved) {
        const excludedKeys = new Set([
          "key",
          "requestid",
          "requestorname",
          "productcategory",
          "productdescription",
          "completeddt",
          "replicateid",
          "keyid1",
          "sampleid",
          "sampleId",
          "__targetFieldKey",
          "__selectedDbColumnName",
          "__selectedValue",
        ]);

        const numericCandidates = [];

        const pushCandidate = (value, priority = 99, sourceKey = "") => {
          const numeric = tryParseNumeric(value);
          if (numeric !== null) {
            numericCandidates.push({ value: numeric, priority, sourceKey });
          }
        };

        // Preserve the primary priority order first.
        pushCandidate(data.dataSet.__selectedInputValue, 1, "__selectedInputValue");
        pushCandidate(data.dataSet.__selectedValue, 2, "__selectedValue");
        pushCandidate(data.dataSet[selectedFieldKey], 3, selectedFieldKey);
        if (data.dataSet.__selectedDbColumnName) {
          pushCandidate(data.dataSet[data.dataSet.__selectedDbColumnName], 4, data.dataSet.__selectedDbColumnName);
        }
        pushCandidate(data.dataSet.avgvalue, 5, "avgvalue");

        // Include normalized key match as additional high-priority candidate.
        const normalizedSelectedFieldKey = String(selectedFieldKey)
          .replace(/[^a-zA-Z0-9]/g, "")
          .toLowerCase();
        const normalizedMatchKey = Object.keys(data.dataSet).find((rowKey) => {
          const normalizedRowKey = String(rowKey)
            .replace(/[^a-zA-Z0-9]/g, "")
            .toLowerCase();
          return (
            normalizedRowKey === normalizedSelectedFieldKey ||
            normalizedRowKey.includes(normalizedSelectedFieldKey) ||
            normalizedSelectedFieldKey.includes(normalizedRowKey)
          );
        });
        if (normalizedMatchKey) {
          pushCandidate(data.dataSet[normalizedMatchKey], 5, normalizedMatchKey);
        }

        // Add remaining numeric values as lower priority candidates.
        Object.keys(data.dataSet).forEach((rowKey) => {
          if (excludedKeys.has(String(rowKey).toLowerCase())) return;
          pushCandidate(data.dataSet[rowKey], 10, rowKey);
        });

        const sortedCandidates = numericCandidates.sort((a, b) => a.priority - b.priority);

        const inRangeCandidate = sortedCandidates.find((candidate) => isInDestinationRange(candidate.value));
        if (inRangeCandidate) {
          importedValue = inRangeCandidate.value;
        } else {
          // Moisture often comes as a fraction (0-1) but destination range is percent (0-100).
          const moistureLikeField =
            String(selectedFieldKey || "").toLowerCase().includes("moist") ||
            String(tempDataSet?.propertyMetaData?.fieldLabel || "").toLowerCase().includes("moisture");

          if (moistureLikeField && typeof fieldMaxRange === "number" && fieldMaxRange > 1) {
            const scaledInRange = sortedCandidates.find((candidate) => {
              const scaled = candidate.value * 100;
              return candidate.value >= 0 && candidate.value <= 1 && isInDestinationRange(scaled);
            });

            if (scaledInRange) {
              importedValue = scaledInRange.value * 100;
            }
          }

          if (importedValue === undefined || importedValue === null) {
            // Prefer high-priority candidates and avoid obvious large identifiers when range exists.
            const sensibleCandidates = sortedCandidates.filter((candidate) => {
              if (typeof fieldMaxRange !== "number") return true;
              const upperBound = Math.max(fieldMaxRange * 5, 1000);
              return Math.abs(candidate.value) <= upperBound;
            });

            const pool = sensibleCandidates.length > 0 ? sensibleCandidates : sortedCandidates;
            if (pool.length > 0) {
              if (typeof fieldMinRange === "number" && typeof fieldMaxRange === "number") {
                const mid = (fieldMinRange + fieldMaxRange) / 2;
                pool.sort((a, b) => {
                  const aDist = Math.abs(a.value - mid);
                  const bDist = Math.abs(b.value - mid);
                  if (aDist !== bDist) return aDist - bDist;
                  return a.priority - b.priority;
                });
              }
              importedValue = pool[0].value;
            } else {
              importedValue = null;
            }
          }
        }
        }

        importedValue = normalizeImportedNumericValue(
          importedValue,
          tempDataSet?.propertyMetaData,
          selectedFieldKey
        );
      }

      tempDataSet["value"] = importedValue === "-" ? null : importedValue;
      tempDataSet["edited"] = false;
      tempDataSet["virtual"] = false;
      tempDataSet.dataSource = data.dataSource;
      tempModuleFieldDataSet[targetModule]["propertyData"][safeTargetIndex][targetFieldKey] = tempDataSet;
      tempModuleFieldDataSet = autoCalulation(targetModule, tempModuleFieldDataSet, fields);

      // Auto-calculation may recompute and overwrite the selected field. Force selected value persist.
      const refreshedRows = tempModuleFieldDataSet[targetModule]["propertyData"] || [];
      const refreshedIndex = refreshedRows.findIndex((row) => Object.prototype.hasOwnProperty.call(row, targetFieldKey));
      if (refreshedIndex > -1) {
        tempModuleFieldDataSet[targetModule]["propertyData"][refreshedIndex][targetFieldKey]["value"] =
          importedValue === "-" ? null : importedValue;
        tempModuleFieldDataSet[targetModule]["propertyData"][refreshedIndex][targetFieldKey]["edited"] = false;
        tempModuleFieldDataSet[targetModule]["propertyData"][refreshedIndex][targetFieldKey]["virtual"] = false;
        tempModuleFieldDataSet[targetModule]["propertyData"][refreshedIndex][targetFieldKey].dataSource = data.dataSource;
      }

      setModuleFieldDataSet(tempModuleFieldDataSet);
      closeAdvancedSearchModal(false);
    } else if (
      data.moduleType === "labvantageCalcResults" &&
      Object.keys(data.dataSet).length > 0 &&
      data.dataSet.data.outputData.length > 0
    ) {
      let tempDataSet = tempModuleFieldDataSet[advancedSearchMetaData.module]["propertyData"];
      let tempNewDataSet = loopCalulatorResults(tempDataSet, data);
      tempModuleFieldDataSet[advancedSearchMetaData.module]["propertyData"] = tempNewDataSet;
      tempModuleFieldDataSet = autoCalulation(advancedSearchMetaData.module, tempModuleFieldDataSet, fields);
      setModuleFieldDataSet(tempModuleFieldDataSet);
      closeAdvancedSearchModal(false);
    }
  };

  const loopCalulatorResults = (tempDataSet, data) => {
    let tempNewDataSet = [];
    tempDataSet.map((propertyRow, index) => {
      tempNewDataSet.push(propertyRow);

      Object.keys(propertyRow).map((key) => {
        if (propertyRow[key] !== undefined) {
          if (Array.isArray(propertyRow[key]["value"])) {
            data.dataSet.data.outputData.map((calulatorRow) => {
              propertyRow[key]["value"].map((propItem) => {
                if (propItem[calulatorRow.dbColumnName] !== undefined) {
                  tempNewDataSet[index][key]["dataSource"] = data.dataSet.data.dataSource;
                  tempNewDataSet[index][key]["virtual"] = false;
                }
              });
            });
            loopCalulatorResults(propertyRow[key]["value"], data);
          } else {
            data.dataSet.data.outputData.map((calulatorRow) => {
              if (propertyRow[calulatorRow.dbColumnName] !== undefined) {
                tempNewDataSet[index][calulatorRow.dbColumnName]["edited"] = false;
                tempNewDataSet[index][calulatorRow.dbColumnName]["value"] = calulatorRow.value;
                tempNewDataSet[index][calulatorRow.dbColumnName]["dataSource"] = data.dataSet.data.dataSource;
                tempNewDataSet[index][calulatorRow.dbColumnName]["virtual"] = false;
              }
            });
          }
        }
      });
    });
    return tempNewDataSet;
  };

  const handleDeleteEvent = () => {
    //dispatch(deleteProperty({id: urlId, type: moduleName}))
  };

  const closeAdvancedSearchModal = () => {
    setAdvancedSearchEvent(false);
    setGraphVisualizer(false);
    document.body.style.overflow = "auto";
    document.body.classList.remove("no-scroll");
  };
  const renderDeletePopup = () => {
    if (deleteEvent && urlParams.id !== "-1") {
      return (
        <>
          <div className="modal-backdrop fade show"></div>
          <DeletePopupWindow
            recordUpdateApiStatus={recordUpdateApiStatus}
            handleDeleteEvent={() => handleDeleteEvent()}
            moduleName={moduleName}
            moduleFieldDataSet={moduleFieldDataSet}
            urlId={urlParams.id}
            closeModal={(e) => closeModal(e)}
          />
        </>
      );
    }
  };
  const renderSavePopup = () => {
    if (saveEvent) {
      let saveType = "newVersion";

      if (urlId === "-1") {
        saveType = "new";
      } else if (
        urlId !== "-1" &&
        moduleFieldDataSet[moduleName] !== undefined &&
        moduleFieldDataSet[moduleName]["header"] !== undefined &&
        moduleFieldDataSet[moduleName]["header"]["status"] !== undefined &&
        moduleFieldDataSet[moduleName]["header"]["status"] === "Draft"
      ) {
        saveType = "update";
      }
      let modeldata = {
        module: moduleName,
        title: `Save ${moduleName} Details`,
        icon: "now-ui-icons arrows-1_cloud-download-93",
        info: `You are about to save all the changes. Please select from the given below options.`,
        urlId: urlId,
        saveType: saveType,
      };
      return (
        <>
          <div className="modal-backdrop fade show"></div>
          <SaveMaterialPopup
            moduleDefaultFieldDataSet={moduleFieldDataSet}
            moduleName={moduleName}
            modal={modeldata}
            saveRecordEvent={(data) => saveRecordEvent(data)}
            recordUpdateApiStatus={recordUpdateApiStatus}
            urlId={urlId}
            closeModal={(e) => closeModal(e)}
          />
        </>
      );
    }
  };
  const renderAdvancedSearchPopup = () => {
    if (advancedSearchEvent) {
      let modeldata = {};
      if (graphVisualizer) {
        modeldata = {
          module: "graphVisualizer",
          calulatorForm: false,
          title: `Visualizer`,
          icon: "now-ui-icons  ui-1_zoom-bold",
        };
      } else {
        modeldata = {
          module: moduleName,
          calulatorForm: false,
          title: `Search & Import`,
          icon: "now-ui-icons  ui-1_zoom-bold",
          info: `You are about to save all the changes. Please select from the given below options.`,
        };
        if (advancedSearchEventType === "labvantageSearch") {
          let tempKey = advancedSearchMetaData.key;
          const normalizedFieldLabel = String(advancedSearchMetaData.fieldLabel || "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
          const calculatorFormOverrideKeys = new Set([
            "solidsGelDiffusivity",
            "gelDiffusivity",
            "swellingCoefficients",
            "swellingCoefficientsK",
            "swellingCoefficientsN",
            "maxCapacity",
          ]);
          let calulatorForm =
            !!advancedSearchMetaData.item[tempKey]["propertyMetaData"]["calculationForm"] ||
            calculatorFormOverrideKeys.has(tempKey) ||
            normalizedFieldLabel.includes("geldiffusivity") ||
            normalizedFieldLabel.includes("swellingcoefficients") ||
            normalizedFieldLabel.includes("samcapacity03psi");
          let compressionForm = !!advancedSearchMetaData.item[tempKey]["propertyMetaData"]["compressionForm"];
          modeldata = {
            module: !compressionForm ? "labvantage" : "compression",
            calulatorForm: calulatorForm,
            title: `${!compressionForm ? "Labvantage" : "Compression"} Search | ${advancedSearchMetaData.fieldLabel}`,
            icon: "now-ui-icons  ui-1_zoom-bold",
            info: `You are about to save all the changes. Please select from the given below options.`,
          };
        }
      }

      return (
        <AdvanceSearch
          modal={modeldata}
          recordUpdateApiStatus={recordUpdateApiStatus}
          urlId={urlId}
          closeAdvancedSearchModal={(e) => closeAdvancedSearchModal(e)}
          importSearchResultSet={(data) => importSearchResultSet(data)}
          advancedSearchEventType={advancedSearchEventType}
          advancedSearchMetaData={advancedSearchMetaData}
          moduleDefaultFieldDataSet={moduleFieldDataSet}
          fields={fields}
        />
      );
    }
  };

  return (
    <div className="content padd-top">
      <div className="row">
        <DefaultBreadCrumb data={breadCrumbData} />
      </div>

      {location?.state?.returnTo ? (
        <div className="row">
          <div className="col-12" style={{ marginBottom: "8px" }}>
            <Link
              to={location.state.returnTo}
              state={{
                scrollToMissingVariables: true,
                selectedGraphId: location?.state?.selectedGraphId,
              }}
            >
              Back to Graph
            </Link>
          </div>
        </div>
      ) : null}

      <div className="row">
        <div className="col-12 header-bar">
          <div className="col-12 content" data-module={moduleName}>
            <Header
              moduleName={moduleName}
              moduleFieldDataSet={moduleFieldDataSet}
              editStatus={editStatus}
              handleHeaderDataUpdate={(data) => handleHeaderDataUpdate(data)}
            />
            <ActionButtons
              moduleName={moduleName}
              moduleFieldDataSet={moduleFieldDataSet}
              handleEditStatus={handleEditStatus}
              handleDeletEvent={(e) => handleDeletEvent(e)}
              editStatus={editStatus}
              handleSaveEvent={handleSaveEvent}
              handleAdvancedSearchStatus={(type, currentStatus) => handleAdvancedSearchStatus(type, currentStatus)}
              urlId={urlId}
            />
          </div>
        </div>
      </div>

      <InputGrid
        moduleName={moduleName}
        moduleDefaultFieldDataSet={moduleFieldDataSet}
        moduleFieldDataSet={defaultMaterialDataSet}
        editStatus={editStatus}
        saveEvent={saveEvent}
        handleEditStatus={handleEditStatus}
        handleSaveEvent={handleSaveEvent}
        handleLabVantageApiCallPopup={handleLabVantageApiCallPopup}
        handleFieldDataUpdate={(data) => handleFieldDataUpdate(data)}
        handleHeaderDataUpdate={(data) => handleHeaderDataUpdate(data)}
        fields={fields}
      />

      {renderSavePopup()}
      {renderDeletePopup()}
      {renderAdvancedSearchPopup()}
    </div>
  );
};

export default Details;
